/* 
  this is the base class for each pump (acid, base, feed, antifoam)
  it implements all the required features 
  in its descendant classes you only specify its type (acid, base, feed, antifoam)
*/

import template	from "./dialog-config.html";
import css		from "./dialog-config.css";

import DialogDevice from "../dialog-device.js";
import Dialog	from "dialog";
import {Label}  from "gui";
import sleep	from "sleep";


class ConfigPumpDialog extends DialogDevice {
  static get template() {
    return template;
  }
  static get css() {
    return css;
  }
  static constructor() {
    customElements.define("fulljs-dialog-config-ezopmp", ConfigPumpDialog);
  }
  constructor(...args) {
    super(...args);

    this.show();
  }
  connectedCallback() {
    super.connectedCallback();
    
    console.log("ConfigPumpDialog.connectedCallback()", this.textboxCurrentMLH.value);
        
    this.spinnerTargetMLH.value = application.devices[this.name].mlh;
  }
  async updatedevice(device) {
    await super.updatedevice(device);

    this.spinnerSumML.value = Math.round(parseFloat(device.sumML)*10)/10;
  }
  spinnerTargetRPM_change(event) {
    server.rcall(`RM_${this.endpoint}_setRPM`, this.spinnerTargetRPM.value).catch(function(result) {
      error(result);
    });
  }
  spinnerTargetMLH_change(event) {
    server.rcall(`RM_${this.endpoint}_setMLH`, this.spinnerTargetMLH.value).catch(function(result) {
      error(result);
    });
  }
  async buttonCalibrate_click(event) {
    try {
      this.buttonCalibrate.icon.style.animationName = "spin";
      this.buttonCalibrate.icon.iconname = "view-refresh";
      await server.rcall(`RM_${this.endpoint}_calibrate`, this.spinnerCalibrationML.value);
     this.buttonCalibrate.icon.iconname = "dialog-ok-apply";    
    } catch(e) {
      this.buttonCalibrate.icon.iconname = "process-stop";          
      error(e.message);
    } finally {
      this.buttonCalibrate.icon.style.animationName = "";
      await sleep(2000);
      this.buttonCalibrate.icon.iconname = "dialog-ok";  
    }
  }
  async buttonClearCalibration_click(event) {
    try {
      this.buttonClearCalibration.icon.style.animationName = "spin";
      this.buttonClearCalibration.icon.iconname = "view-refresh";
      await server.rcall(`RM_${this.endpoint}_clearCalibration`);
      this.buttonClearCalibration.icon.iconname = "dialog-ok-apply";    
    } catch(e) {
      this.buttonClearCalibration.icon.iconname = "process-stop";          
      error(e.message);
    } finally {
      this.buttonClearCalibration.icon.style.animationName = "";
      await sleep(2000);
      this.buttonClearCalibration.icon.iconname = "dialog-ok";   
    }
  }
  
  async buttonClearSum_click() {
    try {      
      this.buttonClearSum.icon.style.animationName = "spin";
      this.buttonClearSum.icon.iconname = "view-refresh";
      await server.rcall(`RM_${this.endpoint}_clearTotalDispensedVolume`);
      this.buttonClearSum.icon.iconname = "dialog-ok-apply";    
    } catch(e) {
      this.buttonClearSum.icon.iconname = "process-stop";    
      error(e.message);
    } finally {
      this.buttonClearSum.icon.style.animationName = "";
      await sleep(2000);
      this.buttonClearSum.icon.iconname = "dialog-ok"; 
    }
  }    
  async buttonDose_click() {
    try {      
      this.buttonDose.icon.style.animationName = "spin";
      this.buttonDose.icon.iconname = "view-refresh";
      await server.rcall(`RM_${this.endpoint}_dose`, this.spinnerML.value);
      this.buttonDose.icon.iconname = "dialog-ok-apply";    
    } catch(e) {
      this.buttonDose.icon.iconname = "process-stop";    
      error(e.message);
    } finally {
      this.buttonDose.icon.style.animationName = "";
      await sleep(2000);
      this.buttonDose.icon.iconname = "dialog-ok";
    }
  }      
  async buttonBlink_click() {
    try {
      this.buttonBlink.icon.style.animationName = "spin";
      this.buttonBlink.icon.iconname = "view-refresh";
      await server.rcall(`RM_${this.endpoint}_blink`);
      this.buttonBlink.icon.iconname = "dialog-ok-apply";    
    } catch(e) {
      this.buttonBlink.icon.iconname = "process-stop";    
      error(e.message);
    } finally {
      this.buttonBlink.icon.style.animationName = "";
      await sleep(2000);
      this.buttonBlink.icon.iconname = "dialog-ok"; 
    }
  }      
}

ConfigPumpDialog.constructor();

export default ConfigPumpDialog;